module.exports = __webpack_public_path__ + "img/onboarding_2.84601bcf.svg";